import React, { useEffect, useRef, useState } from 'react';
import { CenteredMessage } from './CenteredMessage';
import TranscriberComponent from '../AgentComponent/TranscriberComponent';
import TranscriptLogsComponent from './TranscriptLogsComponent';
import { fetchCallDetails, fetchCallDetailsWithId } from '../../utils/api/callAPI';
import SummaryTabComponent from './SummaryTabComponent';
import EvaluationComponent from './EvaluationComponent';
import LeadInfoComponent from './LeadInfoComponent';

export function ConversationAnalysis({ callId, setAnalysisModal }) {
  const [activeTab, setActiveTab] = useState('transcripts');
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const [CallDetails, setCallDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // console.log("CallDetails", CallDetails);
  const [leadInfo, setLeadInfo] = useState({});


  const currentId = true;

  const isMessageLoading = false;
  useEffect(() => {
    setIsLoading(true);
    fetchCallDetailsWithId(callId).then((data) => {
      const call = data?.calls;

      if (!call) return;

      setCallDetails(call);

      const structuredData = call?.analysis?.structuredData;
      const variableValues = call?.assistantOverrides?.variableValues;

      const mergedLeadInfo = {
        ...(structuredData || {}),
        ...(variableValues || {}),
      };

      setLeadInfo(mergedLeadInfo);
    }).finally(() => setIsLoading(false));
  }, [callId]);

  // console.log(leadInfo)


  const tabs = [
    { id: 'transcripts', label: 'Transcripts' },
    { id: 'summary', label: 'Summary' },
    { id: 'evaluation', label: 'Evaluation' },
    { id: 'lead-info', label: 'Lead-Info' }
  ];

  return (
    <div
      className="modal-view-container"  
    >
      <div className="modal-content">
        {/* Header - Improved styling */}
        <div className='flex mx-20 my-10 justify-content-between' style={{ alignItems: 'center' }}>
          <div style={{ fontWeight: '600', fontSize: '18px', color: '#1f2937' }}>
            Call Details : <span>{callId}</span>
          </div>
          <button
            onClick={() => setAnalysisModal(false)}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#6b7280',
              padding: '4px 8px',
              borderRadius: '6px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f3f4f6';
              e.target.style.color = '#374151';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6b7280';
            }}
            title="Close"
          >
            ×
          </button>
        </div>

        {/* Audio Playback UI - Enhanced */}
        {currentId && (
          <div className="chat-input border-top p-10" style={{
            backgroundColor: '#f8fafc',
            borderTop: '1px solid #e2e8f0',
            borderBottom: '1px solid #e2e8f0'
          }}>
            <div className="d-flex align-items-center gap-3 w-100">
              {isLoading ? (
                <div className="w-100 shimmer-loader" style={{
                  width: '100%',
                  height: '40px',
                  borderRadius: '6px',
                  background: 'linear-gradient(to right, #f3f4f6 8%, #e2e8f0 18%, #f3f4f6 33%)',
                  backgroundSize: '800px 104px',
                  animation: 'shimmer 1.5s infinite linear'
                }} />

              ) : (
                <div style={{ width: '100%' }}>

                  <audio
                    controls
                    src={CallDetails?.artifact?.stereoRecordingUrl}
                    className="w-100"
                    preload="auto"
                    style={{
                      borderRadius: '8px',
                      outline: 'none'
                    }}
                  >
                    Your browser does not support the audio element.
                  </audio>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Tabs and Content - Enhanced */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
          <div style={{
            display: 'flex',
            borderBottom: '2px solid #f1f5f9',
            padding: '0 20px',
            backgroundColor: '#fafbfc'
          }}>
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '16px 20px',
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: activeTab === tab.id ? '#2a9d8f' : '#64748b',
                  borderBottom: activeTab === tab.id ? '3px solid #2a9d8f' : '3px solid transparent',
                  transition: 'all 0.2s ease',
                  position: 'relative'
                }}
                onMouseEnter={(e) => {
                  if (activeTab !== tab.id) {
                    e.target.style.color = '#374151';
                    e.target.style.backgroundColor = '#f8fafc';
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== tab.id) {
                    e.target.style.color = '#64748b';
                    e.target.style.backgroundColor = 'transparent';
                  }
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div style={{ padding: '24px', overflowY: 'auto', flex: 1 }}>
            {isLoading ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {[...Array(5)].map((_, index) => (
                  <div
                    key={index}
                    className="shimmer-loader"
                    style={{
                      width: `${90 - index * 5}%`,
                      height: '16px',
                      background: 'linear-gradient(to right, #f3f4f6 8%, #e5e7eb 18%, #f3f4f6 33%)',
                      backgroundSize: '800px 104px',
                      animation: 'shimmer 1.5s infinite linear',
                      borderRadius: '6px'
                    }}
                  />
                ))}
              </div>

            ) : (
              <>
                {activeTab === 'transcripts' && (
                  <TranscriptLogsComponent transcriptData={CallDetails?.messages} />
                )}
                {activeTab === 'summary' && (
                  <SummaryTabComponent summary={CallDetails?.analysis?.summary} />
                )}
                {activeTab === 'evaluation' && (
                  <EvaluationComponent evaluation={CallDetails?.analysis?.successEvaluation} endedReason={CallDetails?.endedReason} />
                )}
                {activeTab === 'lead-info' && (
                  <LeadInfoComponent leadInfo={leadInfo} />
                )}
              </>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}


